import { z } from 'zod/v4';
import { FieldType } from '../data-frame/data-frame';
import { queryMetadataSchema } from './utils';

/**
 * Zod schemas for TabularDataResponse.
 */

const fieldTypeSchema = z.enum(FieldType);

const fieldSchema = z.object({
  name: z.string(),
  type: fieldTypeSchema,
  values: z.array(z.any()),
  columnFlex: z.number().optional(),
});

const dataFrameSchema = z.object({
  fields: z.array(fieldSchema),
  length: z.number(),
});

const tabularDataSchema = z.object({
  data: dataFrameSchema,
  metadata: queryMetadataSchema.optional(),
});

export const tabularDataResponseSchema = z.object({
  type: z.literal('Table'),
  data: tabularDataSchema,
});

export type TabularDataResponseSchema = z.infer<typeof tabularDataResponseSchema>;
